import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import MintUI from 'mint-ui';
import preview from 'vue-photo-preview';
// import 'babel-polyfill'; // This is now handled by the imports above
import VueAwesomeSwiper from 'vue-awesome-swiper';//  Swiper

import router from '@/router/index';
import store from '@/store/index';
// 引入环境变量
import CONFIG from '@/config';
import {
    getSStorage,
    setSStorage,
} from '@/utils';
import {
    initFinder,
} from '@/utils/finder.js';
// 引入重置样式
import '@/assets/css/reset.css';
import '@/assets/css/animate.css';
// 引入mint
import 'mint-ui/lib/style.css';
// 引入重置样式
import '@/assets/css/mint-ui-reset.styl';
// 引入iconfont
import '@/assets/css/iconfont-v4.css';

import '@/assets/css/swiper.css';
// 引入mixin
import baseMixin from '@/mixins/base';
import App from './App.vue';
// import style (<= Swiper 5.x)
import 'swiper/css/swiper.css';
import 'vue-photo-preview/dist/skin.css';
// import Sentry from '@/sentry';
import myPlugin from '@/utils/myPlugin.js';
import { initSentry } from './sentry';
import { tdFpInit } from './utils/tdfp';

// 本地version不等于设置version
if (getSStorage('version') !== CONFIG.version) {
    // 设置最新version
    setSStorage('version', CONFIG.version);
}
Vue.mixin(baseMixin);
Vue.use(MintUI);
Vue.use(preview);
Vue.use(VueAwesomeSwiper/* { default options with global component } */);

Vue.config.productionTip = false;
initFinder();
tdFpInit();
Vue.prototype.$EventBus = new Vue();
// Sentry.init();
Vue.use(myPlugin);

initSentry();

Vue.config.ignoredElements = ['wx-open-launch-app', 'wx-open-launch-weapp'];

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
